"use strict";

require("core-js/modules/es7.array.includes");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var React = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _domLib = require("dom-lib");

var _utils = require("../utils");

var _elementResizeEvent = _interopRequireWildcard(require("element-resize-event"));

var omitProps = ['placement', 'shouldUpdatePosition', 'arrowOffsetLeft', 'arrowOffsetTop', 'positionLeft', 'positionTop', 'getPositionInstance', 'getToggleInstance', 'autoWidth'];
var resizePlacement = ['topLeft', 'topRight', 'leftBottom', 'rightBottom', 'auto', 'autoVerticalLeft', 'autoVerticalRight', 'autoHorizontalBottom'];

var MenuWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2["default"])(MenuWrapper, _React$Component);

  function MenuWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "menuElement", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "bindMenuRef", function (ref) {
      _this.menuElement = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleResize", function () {
      var getPositionInstance = _this.props.getPositionInstance;
      var instance = getPositionInstance ? getPositionInstance() : null;

      if (instance) {
        instance.updatePosition(true);
      }
    });
    return _this;
  }

  var _proto = MenuWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var autoWidth = this.props.autoWidth;

    if (resizePlacement.includes(this.props.placement)) {
      (0, _elementResizeEvent["default"])(this.menuElement, this.handleResize);
    }

    if (autoWidth) {
      this.updateMenuStyle();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.menuElement) {
      (0, _elementResizeEvent.unbind)(this.menuElement);
    }
  };

  _proto.updateMenuStyle = function updateMenuStyle() {
    var getToggleInstance = this.props.getToggleInstance;

    if (this.menuElement && getToggleInstance) {
      var instance = getToggleInstance();

      if (instance && instance.toggle) {
        var width = (0, _domLib.getWidth)((0, _reactDom.findDOMNode)(instance.toggle));
        (0, _domLib.addStyle)(this.menuElement, 'min-width', width + "px");
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        classPrefix = _this$props.classPrefix,
        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "classPrefix"]);
    return React.createElement("div", (0, _extends2["default"])({}, (0, _omit2["default"])(rest, omitProps), {
      ref: this.bindMenuRef,
      className: (0, _classnames["default"])(classPrefix, className)
    }));
  };

  return MenuWrapper;
}(React.Component);

(0, _defineProperty2["default"])(MenuWrapper, "handledProps", ["autoWidth", "className", "classPrefix", "getPositionInstance", "getToggleInstance", "placement"]);
var enhance = (0, _utils.defaultProps)({
  classPrefix: 'picker-menu'
});

var _default = enhance(MenuWrapper);

exports["default"] = _default;